import Service from "../../../Services/index";

const ProductOverview = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        get({ commit }, {page,data}) {
            return Service.productOverview.getProductOverview(page,data);
        },
        get_per_sale({ commit }, data) {
            return Service.productOverview.getProductOverviewPerSale(data);
        },
    }
};

export default ProductOverview;
